import NavBar from '../components/NavBar';
import UserMenu from '../components/UserMenu';
import { CoreNavRail } from '../components/CoreNavRail';
import { useThemeStore } from '../store/themeStore';
import { getDesignTokens } from '../utils/designTokens';

export default function SettingsPage() {
  const { isDarkMode } = useThemeStore();
  const tokens = getDesignTokens(isDarkMode);

  return (
    <div className={`h-screen ${tokens.bg.gradient} relative flex flex-col overflow-hidden pr-20 transition-colors duration-300`}>
      <NavBar className={`${tokens.card.bg} ${tokens.card.shadow} ${tokens.card.border} border`} containerClassName="px-3 py-2">
        <div className="flex items-center gap-3">
          <span className={`text-lg font-semibold ${tokens.text.primary} font-serif`}>Settings</span>
          <span className={`text-sm ${tokens.text.muted}`}>Account & family settings</span>
        </div>
      </NavBar>

      <div className="flex-1 overflow-auto pt-0 px-2 pb-2">
        <div className={`max-w-3xl mx-auto ${tokens.card.bg} ${tokens.card.border} border rounded-landing ${tokens.card.shadow} p-4`}>
          <UserMenu isDarkMode={isDarkMode} isEmbedded />
        </div>
      </div>

      <CoreNavRail active="account" />
    </div>
  );
}
